import React from 'react';
import PropTypes from 'prop-types';
import { Toggle } from './toggle';
import styles from './compare_toggle.css';

const IconTextToggle = ({ icon, handleClick, isSelected }) => (
    <div className={styles.root}>
        <Toggle className={styles.bullet} handleClick={handleClick}>
            {icon}
            <span className={styles.label}>
                { isSelected ? 'Selected' : 'Compare' }
            </span>
        </Toggle>
    </div>
);

IconTextToggle.propTypes = {
    icon: PropTypes.element.isRequired,
    handleClick: PropTypes.func.isRequired,
    isSelected: PropTypes.bool.isRequired
};

export { IconTextToggle };
